export default __webpack_public_path__ + "static/media/Sur_mesure_Aluminium.6386ada7.jpg";